import { mapGetters } from 'vuex'

/**
 * Mixin para verificar acceso a módulos y features de suscripción.
 *
 * Uso:
 *   import suscripcionMixin from '@/mixins/suscripcion.mixin'
 *   mixins: [suscripcionMixin]
 *
 *   v-if="tieneModulo('ventas')"
 *   v-if="tieneFeature('ventas.descuentos')"
 *   v-if="tieneServicio('cartera_cheques')"   // add-on contratado
 */
export default {
    computed: {
        ...mapGetters('auth', ['tieneModulo', 'tieneFeature', 'tieneServicio']),
        suscripcionVigente() {
            return this.$store.state.auth.suscripcion?.vigente || false
        },
    },
}
